// Day-key math (runtime-agnostic, `YYYY-MM-DD` → UTC millis).
export const MS_PER_DAY = 86_400_000;

export function eachDateInclusive(start: string, end: string): string[] {
  if (start > end) return [];
  const result: string[] = [];
  const cursor = new Date(`${start}T00:00:00.000Z`);
  const last = new Date(`${end}T00:00:00.000Z`);
  while (cursor.getTime() <= last.getTime()) {
    result.push(cursor.toISOString().slice(0, 10));
    cursor.setUTCDate(cursor.getUTCDate() + 1);
  }
  return result;
}

export function dayKeyToUtcMs(key: string): number {
  const [year, month, day] = key.split('-').map(Number);
  return Date.UTC(year, month - 1, day);
}

export function dayKeyToNoonUtc(key: string): Date {
  return new Date(dayKeyToUtcMs(key) + MS_PER_DAY / 2);
}

export function addDaysToDayKey(key: string, days: number): string {
  return new Date(dayKeyToUtcMs(key) + days * MS_PER_DAY).toISOString().slice(0, 10);
}

export function eachDayKey(from: string, to: string): string[] {
  const days: string[] = [];
  for (let day = from; day <= to; day = addDaysToDayKey(day, 1)) days.push(day);
  return days;
}

export function isWeekendDayKey(key: string): boolean {
  const weekday = new Date(dayKeyToUtcMs(key)).getUTCDay();
  return weekday === 0 || weekday === 6;
}

export function isMonthKey(value: string | null): value is string {
  return value !== null && /^\d{4}-(0[1-9]|1[0-2])$/.test(value);
}

export function monthKeyOf(key: string): string {
  return key.slice(0, 7);
}

export function isDayRangeWithin(dateFrom: string, dateTo: string, maxDays: number): boolean {
  const spanMs = dayKeyToUtcMs(dateTo) - dayKeyToUtcMs(dateFrom);
  return spanMs >= 0 && spanMs <= (maxDays - 1) * MS_PER_DAY;
}

export function isOvernight(startTime: string, endTime: string): boolean {
  const validTime = /^(?:[01]\d|2[0-3]):[0-5]\d$/;
  return validTime.test(startTime) && validTime.test(endTime) && endTime < startTime;
}

export function resolveEndDateKey(dateKey: string, startTime: string, endTime: string): string {
  return isOvernight(startTime, endTime) ? addDaysToDayKey(dateKey, 1) : dateKey;
}
